/** @format */

import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

// 查询组织选择器
export function orgFindTreeDataByAll(data) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacOrg/findTreeDataByAll',
		method: 'post',
		data,
	});
}

export function allNoticeAll() {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacOrg/getTreeData',
		method: 'post',
	});
}
// 查询用户组列表数据
export function queryPageList(data: API.positionParam) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacGroup/page',
		method: 'post',
		data,
	});
}
// 查询岗位树
export function positionFindTreeDataByAll(data) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacPosition/findTreeDataByAll',
		method: 'post',
		data,
	});
}
// 查询列表数据
export function query(type, data) {
	let url = '/rbac/employee/page';
	if (type === 'org') {
		url = '/rbac/user/query4Org';
	} else if (type === 'position') {
		url = '/rbac/user/query4Position';
	} else if (type === 'role') {
		url = '/rbac/user/query4Role';
	} else if (type === 'group') {
		url = '/rbac/user/query4Group';
	}
	return request<BaseResponse<API.BasePositionResult>>({
		url: `/base${url}`,
		method: 'post',
		data,
	});
}
// 获取所有用户组
export function groupFindTreeDataByAll(data) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacGroup/findTreeDataByAll ',
		method: 'post',
		data,
	});
}
// 查询节点
export function findTreeData(data: API.positionParam) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacPosition/findAllPositionTree',
		method: 'post',
		data,
	});
}
// 查询用户组的角色树
export function queryWithSys(data) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacRole/queryWithSys',
		method: 'post',
		data,
	});
}
// 获取所有子系统
export function findAllSubSystemOne() {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/system/subsys/findAllSubSystem',
		method: 'get',
	});
}
// 角色列表查询
export function roleQueryPageList(data: API.positionParam) {
	return request<BaseResponse<API.BasePositionResult>>({
		url: '/base/rbac/rbacRole/page',
		method: 'post',
		data,
	});
}
// 查询子系统下拉
export function subsystemList(data) {
	return request<BaseResponse<API.BaseConfigResult>>({
		url: '/base/system/subsys/list',
		method: 'post',
		data,
	});
}
